/**
* @ngdoc service
* @name Paginator
*
* @deprecated Use "pager" directive instead
*
* @description
* Used for pagination in tables where we do not use table-view directive
*/

(function () {
  'use strict';

  app
    .service('paginator', paginator);

  function paginator() {
    var ITEMS_ON_PAGE = 25;
    var pages = [];
    var items = [];
    var allMode = false;

    return {
      paginate: paginate,
      goTo: goTo,
      openAllMode: openAllMode,
      toggleAllMode: toggleAllMode,
      resetAllMode: resetAllMode
    };

    function paginate(filteredItems, orderProperty, reverse, rowsPerPage) {
      items = filteredItems;
      sortItems(orderProperty, reverse);
      makePages(rowsPerPage);
      if (pages.length > 1 || allMode) return goTo(0);
      else return { items: items };
    }

    function sortItems(orderProperty, reverse) {
      var sortedItems = _.sortBy(items, function (item) {
        var properties = orderProperty.split('.');
        var value = item;
        properties.forEach(function (property) {
          value = value[property];
        });
        return value;
      });
      items = sortedItems;
      if (reverse) items.reverse();
    }

    function makePages(rowsPerPage) {
      var itemsOnPage = rowsPerPage ? rowsPerPage : ITEMS_ON_PAGE;
      itemsOnPage = allMode ? items.length : itemsOnPage;
      var pageRange = _.range(Math.ceil(items.length / itemsOnPage));
      pages = [];

      if (!allMode && pageRange.length < 2) return;

      pageRange.forEach(function (pageNumber) {
        var isLast = pageNumber === pageRange.length - 1;
        var page = {
          isFirst: !pageNumber,
          start: itemsOnPage * pageNumber + 1,
          end: isLast ? items.length : itemsOnPage * (pageNumber + 1),
          number: pageNumber,
          isLast: isLast,
          allMode: allMode
        };

        page.name = page.start + '-' + page.end + ' of ' + items.length;
        pages.push(page);
      });
    }

    function goTo(pageNumber) {
      if (pageNumber < 0 || pageNumber > pages.length - 1) return {};
      var page = pageNumber === 'last' ? pages[pages.length - 1] : pages[pageNumber];
      return {
        page: page,
        items: items.slice(page.start - 1, page.end)
      };
    }

    function openAllMode() {
      allMode = true;
    }

    function toggleAllMode() {
      allMode = !allMode;
    }

    function resetAllMode() {
      allMode = false;
    }
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/pagination/pagination.service.js